import classes from './toggle.module.scss';
import { create, registerCustomElement } from '../utils.mjs';

export class Toggle extends HTMLElement {
	constructor() {
		super();
	}

	static get observedAttributes() {
		return ['checked'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'checked') {
			this.querySelector('input')?.toggleAttribute('checked', newValue != null);
		}
	}

	connectedCallback() {
		const label = create(`label.${classes.label}`);
		const thumb = create(`div.${classes.thumb}`);

		const input = create(`input.${classes.input}`);
		const checked = this.getAttribute('checked');

		input.toggleAttribute('checked', checked != null);
		input.type = 'checkbox';

		label.append(input, thumb);
		this.appendChild(label);
	}
}

registerCustomElement('imt-forman-toggle', Toggle);
